import {Typography} from '@logistics-frontend/blocks'
import React, {memo} from 'react'

import {i18n} from 'src/shared/config'

import {ConfirmModal} from '../ConfirmModal/ConfirmModal'
import * as classes from './OptimizeRouteConfirmModal.classes'
import {Props} from './types'

export const OptimizeRouteConfirmModal = memo<Props>(function OptimizeRouteConfirmModal(props) {
  const {optimizationState, onAccept, isOpen, onDecline} = props

  return (
    <ConfirmModal
      isPending={optimizationState === 'pending'}
      locale={{
        title: i18n('cargo.create.rout-change.optimize_route-question', 'Оптимизировать\nмаршрут?'),
        submit:
          optimizationState === 'pending'
            ? i18n('cargo.create.rout-change.optimization', 'Оптимизация...')
            : i18n('cargo.create.rout-change.optimize', 'Оптимизировать'),
      }}
      ModalProps={{className: classes.paper}}
      onCancel={onDecline}
      onSubmit={onAccept}
      open={isOpen}
    >
      <Typography className={classes.body} variant="caption1">
        {i18n('cargo.create.rout-change.optimization_cannot_be_undone', 'Оптимизацию нельзя будет отменить')}
      </Typography>
    </ConfirmModal>
  )
})
